import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PrivateComponent } from './shared/components/layouts/private/private.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { PublicComponent } from './shared/components/layouts/public/public.component';
import { RegistrationPageComponent } from './pages/registration-page/registration-page.component';
import { AuthGuard } from '../app/shared/services/auth/auth.guard';
import { PreviewGuard } from '../app/shared/services/preview/preview.guard';
import { StandardContentPageComponent } from './pages/standard-content-page/standard-content-page.component';
// import { GradesPageComponent } from './pages/grades-page/grades-page.component';
// import { ExamsPageComponent } from './pages/exams-page/exams-page.component';
// import { LinksPageComponent } from './pages/links-page/links-page.component';
// import { SchedulePageComponent } from './pages/schedule-page/schedule-page.component';
// import { MessagesPageComponent } from './pages/messages-page/messages-page.component';
// import { BillingAccountPageComponent } from './pages/billing-account-page/billing-account-page.component';
// import { DeanOfStudentsPageComponent } from './pages/dean-of-students-page/dean-of-students-page.component';
import { PortalPreviewPageComponent } from './pages/portal-preview-page/portal-preview-page.component';
import { SkeletonComponent } from './loadingSkeletons/homepage-skeleton/skeleton.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/private/home',
    pathMatch: 'full',
  },
  {
    path: 'en',
    redirectTo: '/private/en/home',
    pathMatch: 'full',
  },
  {
    path: 'private',
    component: PrivateComponent,
    children: [
      {
        path: 'home',
        component: HomePageComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'en/home',
        component: HomePageComponent,
        canActivate: [AuthGuard],
      },
      {
        path: '**',
        component: StandardContentPageComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'public',
   component: PublicComponent, //todo:do not forget to return this line 
  //  component: HomepageSkeletonComponent,
    children: [
      {
        path: 'login',
        component: RegistrationPageComponent,
        canActivate: [AuthGuard]   },
       
      {
        path: 'en/login',
        component: RegistrationPageComponent,
        canActivate: [AuthGuard]
      },
    ],
  },
  {
    path: '**',
    component: PortalPreviewPageComponent,
    canActivate: [PreviewGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}

// {
//   path: 'links',
//   component: LinksPageComponent,
// },
// {
//   path: 'grades',
//   component: GradesPageComponent,
// },
// {
//   path: 'exams',
//   component: ExamsPageComponent,
// },
// {
//   path: 'schedule',
//   component: SchedulePageComponent,
// },
// {
//   path: 'messages',
//   component: MessagesPageComponent,
// },
// {
//   path: 'billing-account',
//   component: BillingAccountPageComponent,
// },
// {
//   path: 'dean-of-students',
//   component: DeanOfStudentsPageComponent,
// },
